import { createContext } from 'react';
import { AuthStateProps } from './AuthContext.types';

export const AuthContext = createContext<AuthStateProps>({} as AuthStateProps);
